import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { environment } from './../../../../environments/environment';
import { ErrorHandlerService } from './../../../core/error-handler.service';
import { ExtratoFiltro, ExtratoService } from './../../../core/services/moduloFinanceiro/extrato.service';
import { PdfGeneratorService } from '../../../core/services/relatorio/pdfGeneratorService.service';
import { ToastyService } from 'ng2-toasty';

@Component({
  standalone: false,
  selector: 'cotacao-preco',
  templateUrl: './cotacao-preco.component.html',
})
export class CotacaoPrecoComponent implements OnInit, OnChanges {

  pthpId: any;

  extratoFiltro = new ExtratoFiltro()

  periodoInicial
  periodoFinal

  listaDespesasComuns = [];
  listaDespesasPessoal = [];
  listaCotacao = [];

  loading: boolean = false;

  @Input() periodoInicialInput;
  @Input() periodoFinalInput;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private extratoService: ExtratoService,
    private errorHandler: ErrorHandlerService,
    private pdfGeneratorService: PdfGeneratorService,
    private toasty: ToastyService,
  ) { }

  ngOnInit() {

    this.pthpId = JSON.parse(sessionStorage.getItem("planoTrabalhoHasProponenteId"));

  }

  ngOnChanges(changes: any): void {
    if (changes.periodoInicialInput) {
      this.periodoInicial = moment(changes.periodoInicialInput.currentValue).format("YYYY-MM-DD")
    }
    if (changes.periodoFinalInput) {
      this.periodoFinal = moment(changes.periodoFinalInput.currentValue).format("YYYY-MM-DD")
    }
    setTimeout(
      function () { this.gerarComprovantes(); }.bind(this), 10
    );
  }

  //GERAR RELAÇÃO
  gerarComprovantes() {

    this.loading = false;

    this.extratoFiltro.planoTrabalhoHasProponenteId = this.pthpId
    this.extratoFiltro.itensPorPagina = 10000 //TODO: retorno máximo de registros

    this.extratoFiltro.dataCadastroInicial = this.periodoInicial
    this.extratoFiltro.dataCadastroFinal = this.periodoFinal

    this.extratoService.pesquisarDtoRelatorioCotacao(this.extratoFiltro)
      .then(resultado => {
        this.listaCotacao = resultado;
        // this.listaDespesasComuns = [];
        // this.listaDespesasPessoal = [];

        // resultado.content.forEach(element => {
        //   if(element.despesaId){
        //     this.listaDespesasComuns.push(element);
        //   }
        //   if(element.pagamentoPessoalId){
        //     this.listaDespesasPessoal.push(element);
        //   }
        // });
        this.loading = true;
      }).catch(erro => {
        this.errorHandler.handle(erro);
        this.loading = true;
      });
  }

  generateReport() {
    if (!this.possuiDadosParaRelatorio()) {
      return this.toasty.warning("Não existem cotações de preços cadastradas para o período informado.");
    }

    const content: any = [
      {
        text: "Cotações de preços realizadas",
        marginBottom: 5,
        marginTop: 10,
        fontSize: 12,
        bold: true,
      },
      this.generateContentCotacao()
    ];

    const pdfDocument = this.pdfGeneratorService.generatePdfWithLogo(
      content,
      "Relatório de cópia das cotações de preços realizadas",
      "Relatório de cópia das cotações de preços realizadas",
      this.periodoInicial,
      this.periodoFinal
    );

    pdfDocument.open();
  }

  generateContentCotacao() {
    let body = [[
      { text: 'Meta/Etapa', style: 'tableheader' },
      { text: 'Despesa', style: 'tableheader' },
      { text: 'Fornecedor', style: 'tableheader' },
      { text: 'Valor', alignment: 'center', style: 'tableheader' },
      { text: 'Cotações', style: 'tableheader' },
      { text: 'Justificativa', style: 'tableheader' },
      { text: 'Data fato', alignment: 'center', style: 'tableheader' },
    ]];

    (this.listaCotacao || []).forEach(item => {
      body.push([
        { text: "Meta: " + this.formatarDado(item.detFisHasDespMeta) + "\nEtapa: " + this.formatarDado(item.detFisHasDespEtapa), style: 'table' },
        { text: this.retornaDespesas(item), style: 'table' },
        { text: "CPF/CNPJ: " + this.formatarDado(item.cpfCnpjVencedor) + "\nNome: " + this.formatarDado(item.nomeFavorecido), style: 'table' },
        { text: this.formataValor(item.valor), alignment: 'center', style: 'table' },
        { text: this.retornaCotacoes(item), style: 'table' },
        { text: this.formatarDado(item.justificativaAusenciaProposta), style: 'table' },
        { text: item.dataFatoMovimentacao ? moment(item.dataFatoMovimentacao).format('DD/MM/YYYY') : "Data não informada", alignment: 'center', style: 'table' },
      ]);
    });

    return {
      table: {
        widths: [110, 120, 130, 70, 120, 120, 70],
        headerRows: 1,
        body: body,
      },
      layout: {
        defaultBorder: false,
        fillColor: function (rowIndex, node, columnIndex) {
          return rowIndex % 2 === 0 ? "#EEEEEE" : null;
        },
      },
    };
  }

  possuiDadosParaRelatorio() {
    return (this.listaCotacao || []).some(item =>
      (item.proposta && item.proposta.length > 0) || !!item.justificativaAusenciaProposta
    );
  }

  retornaDespesas(item: any) {
    return ((item && item.detFisHasDespEspecificacao) || []).join("\n");
  }

  retornaCotacoes(item: any) {
    const cotacoes = ((item && item.proposta) || []).map(proposta => proposta.proposta);
    return cotacoes.length > 0 ? cotacoes.join("\n") : "Sem cotação anexada";
  }

  formatarDado(data) {
    return data === null || data === undefined || data === "" ? "Não informado" : data;
  }

  formataValor(valor) {
    return (valor || 0).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }

  displayOpenModalView
  urlDocumento
  viewDownload
  openViewPDF(item){
    this.displayOpenModalView = true;
    this.urlDocumento = environment.downloadFileUrl + "/" + item;
    item.toLowerCase().includes(".pdf") ? this.viewDownload=true : this.viewDownload=false
  }

}
